import type { UseQueryOptions } from '@tanstack/react-query';

import { getSavedFilters, type KyInstance, type SavedFilter, type SavedFilterSource } from '@enterprise/api';
import type { OperationResultWithData } from '@enterprise/types';

import { savedFiltersQueryKeys } from '@/features/profile/saved-filters/common/saved-filters-query-keys';

/**
 * Builds the TanStack Query options for the user's saved filters for a single source.
 *
 * Shared between {@link useGetSavedFilters} (UI hook) and `defaultSavedFilterLoader`
 * (route loader) so both read and write the same cache entry.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param source - Page scope (Package Manager / List Manager).
 */
export const createSavedFiltersQuery = (
  instance: KyInstance,
  source: SavedFilterSource
): UseQueryOptions<OperationResultWithData<SavedFilter[]>, Error, SavedFilter[]> => {
  return {
    queryFn: () => {
      return getSavedFilters(instance, source);
    },
    queryKey: savedFiltersQueryKeys.list(source),
    select: (result) => {
      if (result.failure) {
        return [];
      }

      return result.data ?? [];
    },
  };
};
